import Typography from '@components/v2/ui/Typography/Typography';
import { ButtonBaseProps } from '@mui/material';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { breakWordsByLetter } from '../../../contexts/order.utils';

interface OrderProductButtonContentProps extends ButtonBaseProps {
  startAdornment?: React.ReactNode;
  prefix?: string;
  label?: string;
}

const useStyles = makeStyles<{ isDisabled: boolean }>()((theme, { isDisabled }) => ({
  startAdornment: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: 156,
    },
    [theme.breakpoints.only('lg')]: {
      maxWidth: 146,
    },
    [theme.breakpoints.only('md')]: {
      maxWidth: 102,
    },
    [theme.breakpoints.only('sm')]: {
      maxWidth: 119,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100vw - 315px)',
    },
  },

  prefix: {
    flexShrink: 0,
  },

  label: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },

  text: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    lineHeight: '14px',
    fontWeight: 400,
    ...(isDisabled ? {} : { color: theme.palette.text.primary }),
    overflowWrap: 'break-word',
  },
}));

const OrderProductButtonContent = ({
  startAdornment,
  prefix,
  label,
  disabled = false,
}: OrderProductButtonContentProps) => {
  const { classes, cx } = useStyles({ isDisabled: disabled });

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: '4px',
      }}
    >
      {startAdornment && <>{startAdornment}</>}
      {prefix && (
        <Typography variant="body2" className={cx(classes.text, classes.prefix)}>
          {prefix}
        </Typography>
      )}
      {label && (
        <div className={classes.label}>
          <Typography variant="body2" align="left" className={classes.text}>
            {breakWordsByLetter(label.toLowerCase())}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default memo(OrderProductButtonContent);
